import React, { useContext } from "react"
import { PriceContext } from "../../PriceContext"
import { TariffKey } from "./types"
import Button from "@shared/uiNew/Button/button"
import * as styles from "../../newStyles.module.scss"

interface ButtonsProps {
  tariff: TariffKey
  trackOnClick?: () => void
}

const enterpriseEventByTariff: Partial<Record<TariffKey, string>> = {
  EnterpriseMarketing: "Отправил заявку на «Enterprise Маркетинг»",
  EnterpriseSupport: "Отправил заявку на «Enterprise Поддержка»",
}

const Buttons: React.FC<ButtonsProps> = ({ tariff, trackOnClick }) => {
  const { calculator, range, text } = useContext(PriceContext)

  if (!calculator) return null

  const plans = calculator.plans ?? {}

  const plansMap = {
    Core: plans.core,
    Support: plans.support,
    Marketing: plans.marketing,
    MarketingExpert: plans.marketingExpert,
    EnterpriseMarketing: plans.enterpriseMarketing,
    EnterpriseSupport: plans.enterpriseSupport,
  }

  const options = plansMap[tariff] ?? null

  if (!Array.isArray(options)) return null

  const option = options[range] ?? {}
  const hasPrice = Boolean(Number(option.price))

  const hiddenClass = styles.buttonHidden
  const visibleClass = styles.buttonVisible

  const consultationHrefBase = "#open-modal-consultation?title=Связаться с нами"
  const enterpriseEvent = enterpriseEventByTariff[tariff]

  const consultationHref = enterpriseEvent ? `${consultationHrefBase}&event=${encodeURIComponent(enterpriseEvent)}` : consultationHrefBase

  return (
    <>
      <Button
        type="link"
        variant="outline"
        text={text?.buttons?.demo ?? "Связаться с нами"}
        href={consultationHref}
        onClick={trackOnClick}
        style={hasPrice ? hiddenClass : visibleClass}
      />

      <Button
        type="link"
        variant="primary"
        text={text?.buttons?.freeDays ?? "Выбрать этот тариф"}
        href="/panel/unauthorized/register"
        target="_blank"
        onClick={trackOnClick}
        style={hasPrice ? visibleClass : hiddenClass}
      />
    </>
  )
}

export default Buttons
